module.exports = __webpack_public_path__ + "static/media/wcgBloodyMary.9844c218.jpg";